import { useRouterStore } from "@/store/router";
import { useUserStore } from "@/store/useUserStore";

const url = location.origin;

export const useUrl = () => {
  const route = useRouterStore()
  const userStore = useUserStore()

  const getFullMapUrl = (item, type) => {
    let id = item.mapId
    if (type === 'links') id = item.linkId
    let link = `${url}/map?domain=${userStore.uid}&doc=${id}&key=${item.key}`
    if (type) link += `&type=${type}`
    return link
  }

  const getQuery = () => {
    const miURL = new URL(window.location.href)
    const parametrosObjeto = {}
    for (const [clave, valor] of miURL.searchParams.entries()) {
      parametrosObjeto[clave] = decodeURIComponent(valor)
    }
    return parametrosObjeto
  }

  const crearArrayNumeros = (n1, n2) =>
    Array.from({ length: n2 - n1 + 1 }, (_, index) => n1 + index)

  const prepareItem = (item) => {
    let [numero, zona, center, color, angle, zoom, mzNumbers, referencia, limits, notas, pendiente, tipo, routes] = item
    zona = zona === "-" ? "" : zona
    if (!pendiente) pendiente = crearArrayNumeros(1, mzNumbers.length)
    return {
      numero, zona, center,
      color: { backgroundColor: color[0], color: color[1] },
      angle, zoom, mzNumbers, referencia, limits, notas, pendiente, tipo, routes,
    }
  }

  const getItemFromQuery = (doc) => {
    if (doc.dataMap) {
      const items = doc.dataMap.map(item => prepareItem(item))
      return Array.isArray(items) ? items : [items]
    }
    throw new Error("No se encontraron items en la url")
  }

  const getLinkInforme = (item, manzanas) => {
    const zona = item.zona || ""
    const timestamp = Date.now()
    const manzanasTrue = []
    for (let k in manzanas) {
      if (manzanas[k]) manzanasTrue.push(parseInt(k))
    }
    return `${url}/informe?data=${encodeURIComponent(JSON.stringify([item.numero, zona, manzanasTrue, timestamp]))}`
  }

  const getInforme = () => {
    let query = window.location.href.split('informe?data=')[1]
    query = decodeURIComponent(query)
    let data = false
    try { data = JSON.parse(query) } catch { /* URL malformada */ }
    if (!data) {
      route.$patch({ page: 'listaTerritorio' })
      return {}
    }
    const [numero, manzanas, timestamp] = data
    const zona = data.zona || ""
    return { numero, zona, manzanas, timestamp, territorio: `${zona}${numero}` }
  }

  return { getFullMapUrl, getQuery, getItemFromQuery, getLinkInforme, getInforme }
}
